/* THIS FILE IS GENERATED. DO NOT EDIT IT. */
import * as React from 'react';

function SvgValueDecrease16(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={16}
      height={16}
      fill='none'
      viewBox='0 0 16 16'
      {...props}
    >
      <circle cx={8} cy={8} r={8} fill='#FF7C35' opacity={0.1} />
      <path
        fill='#FF7C35'
        fillRule='evenodd'
        d='M9.846 9.616V5.593h1.5v6.584H4.761v-1.5h4.023L3.773 5.664l1.06-1.06 5.013 5.012z'
      />
    </svg>
  );
}

export default SvgValueDecrease16;
